import React, { useState, useEffect } from 'react';
import './Login.css';

const resolveApiUrl = () => {
  const configuredUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

  try {
    const parsedUrl = new URL(configuredUrl);
    const isLocalHost = parsedUrl.hostname === 'localhost' || parsedUrl.hostname === '127.0.0.1';
    const runtimeHost = typeof window !== 'undefined' ? window.location.hostname : '';
    const runtimeIsRemote = runtimeHost && runtimeHost !== 'localhost' && runtimeHost !== '127.0.0.1';

    if (isLocalHost && runtimeIsRemote) {
      parsedUrl.hostname = runtimeHost;
      return parsedUrl.toString().replace(/\/$/, '');
    }

    return configuredUrl.replace(/\/$/, '');
  } catch (e) {
    return configuredUrl.replace(/\/$/, '');
  }
};

function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [diagnostic, setDiagnostic] = useState('');

  const API_URL = resolveApiUrl();

  useEffect(() => {
    console.log('Frontend API URL:', API_URL);
    setDiagnostic(`Се користи API: ${API_URL}`);
  }, [API_URL]);

  const testConnection = async () => {
    setDiagnostic('Тестирање на конекција...');
    try {
      const response = await fetch(`${API_URL}/health`, {
      method: 'GET'
    });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      setDiagnostic(`УСПЕХ! Поврзано со ${API_URL}. Одговор: ${JSON.stringify(data).substring(0, 100)}`);
    } catch (err) {
      setDiagnostic(`НЕУСПЕХ! Грешка: ${err.message}. URL: ${API_URL}`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Use native fetch instead of axios to bypass any axios issues
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Најавата не успеа');
      }

      const data = await response.json();
      console.log('Login response:', data);
      console.log('Token in response:', data.token ? `${data.token.substring(0, 20)}...` : 'NO TOKEN');
      
      if (!data.token) {
        throw new Error('Не е добиен токен од серверот');
      }
      
      if (data.user?.role !== 'admin') {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  throw new Error('Оваа страница е само за администратор');
}

localStorage.setItem('token', data.token);
localStorage.setItem('user', JSON.stringify(data.user));
console.log('Token stored in localStorage:', localStorage.getItem('token') ? 'YES' : 'NO');

onLoginSuccess(data.user);
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Најавата не успеа');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Најава за администратор</h1>
        {diagnostic && (
          <div style={{
            background: (diagnostic.includes('SUCCESS') || diagnostic.includes('УСПЕХ')) ? '#d4edda' : '#fff3cd',
            padding: '10px',
            marginBottom: '15px',
            borderRadius: '5px',
            fontSize: '12px',
            wordBreak: 'break-all'
          }}>
            {diagnostic}
          </div>
        )}
        <button 
          onClick={testConnection}
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '15px',
            background: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Тестирај конекција
        </button>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Е-пошта"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <div className="password-input-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Лозинка"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="toggle-password-btn"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? '👁️' : '👁️‍🗨️'}
            </button>
          </div>
          {error && <div className="error">{error}</div>}
          <button type="submit" disabled={loading}>
            {loading ? 'Се најавува...' : 'Најава'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
